var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricingRequests(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 16.001C0.25 15.5868 0.585786 15.251 1 15.251H15.5C15.9142 15.251 16.25 15.5868 16.25 16.001C16.25 16.4152 15.9142 16.751 15.5 16.751H1C0.585786 16.751 0.25 16.4152 0.25 16.001Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.22217 13.5283C3.80795 13.5283 3.47217 13.1925 3.47217 12.7783L3.47217 6.33388C3.47217 5.91966 3.80795 5.58388 4.22217 5.58388C4.63638 5.58388 4.97217 5.91966 4.97217 6.33388L4.97217 12.7783C4.97217 13.1925 4.63638 13.5283 4.22217 13.5283Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2778 13.5283C11.8636 13.5283 11.5278 13.1925 11.5278 12.7783L11.5278 6.33388C11.5278 5.91966 11.8636 5.58388 12.2778 5.58388C12.692 5.58388 13.0278 5.91966 13.0278 6.33388L13.0278 12.7783C13.0278 13.1925 12.692 13.5283 12.2778 13.5283Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 13.5283C7.83579 13.5283 7.5 13.1925 7.5 12.7783L7.5 1.50054C7.5 1.08633 7.83579 0.750543 8.25 0.750543C8.66421 0.750543 9 1.08633 9 1.50054L9 12.7783C9 13.1925 8.66421 13.5283 8.25 13.5283Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingRequests);
export default __webpack_public_path__ + "static/media/pricing-requests.eeb852d5075e96f2eb9db63b099c7c9a.svg";
export { ForwardRef as ReactComponent };